import styled from 'styled-components';
import { Flex } from '@rebass/grid';
import { Text } from 'app/shared/ui';

import { zIndex, colorV2 } from 'app/shared/styles_js/variables';

export const ModalSt = styled(Flex).attrs(() => ({
  width: 'calc(100% - 48px)',
  bg: colorV2.white,
}))`
  position: fixed;
  z-index: ${zIndex.slideIn};
  background: ${colorV2.sunbeanLight};
  right: 0;
  bottom: 65px;
  left: 0;
  overflow: hidden;
  height: 84px;
  margin: auto;
  border-radius: 4px;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
  transform: ${({ mode }) => {
    switch (mode) {
      case 'slideIn':
        return 'translateY(0)';
      case 'slideInPDP':
        return 'translateY(-40px)';
      case 'bouncePDP':
        return 'translateY(-80px)';
      case 'slideOut':
        return 'translateY(150px)';
      default:
        return 'translateY(150px)';
    }
  }};
  transition: transform 0.4s ease-in-out;
`;

export const ImageSt = styled.div`
  display: flex;
  overflow: hidden;
  height: 100%;
  flex: 1;
  flex-direction: row;
  /* align-items: center; */
  justify-content: center;

  img {
    width: 100%;
    max-width: none;
    height: 100%;
    object-fit: cover;
  }
`;

export const IconCloseSt = styled.i`
  cursor: pointer;
  position: absolute;
  top: 12px;
  right: 12px;
`;

export const SignupButtonTextSt = styled(Text).attrs(() => ({
  fontSize: '14px',
  color: colorV2.mintDark,
}))`
  text-decoration: underline;
  font-weight: bold;
`;

export const BannerTextSt = styled(Text).attrs(() => ({
  fontWeight: 'Bold',
  margin: 0,
  lineHeight: 1.45,
  color: colorV2.tarmacGrey,
}))``;
